/**
 * brand.tsx — the Volkswagen roundel from the design.
 *
 * The three paths are lifted verbatim from design/Tool Upload P1 (1).svg, where the mark is drawn at
 * 32x32 on the canvas at 16,16 in #022B30. Document order is load-bearing: the two letterform strokes
 * are painted first and the ring last (the ring is an annulus, so it frames rather than covers them).
 * The viewBox keeps the original canvas coordinates instead of re-origining them, so the geometry can
 * be diffed against the frame without arithmetic.
 *
 * currentColor rather than a hard-coded fill, so the mark inherits --tb-ink or --tb-accent-ink from
 * whatever surface it sits on (audit-tokens.mjs would reject the literal, and rightly).
 */
export function VwRoundel({ title = 'Volkswagen' }: { title?: string }) {
  return (
    <svg viewBox="16 16 32 32" role="img" aria-label={title} focusable="false">
      <path
        d="M27.004 44.125L18.4375 26.9234L18.6172 25.5024L19.8003 24.1263L27.3484 39.1889H27.4682L30.3587 32.6373L30.5833 32.4129H33.5187L36.6188 39.1889H36.7086L44.2267 24.1263L44.9007 24.3955L45.6195 26.8785C45.6195 26.8785 36.9782 44.3344 36.9632 44.3494C36.9482 44.3643 36.5217 44.4847 36.2893 44.3494C36.1096 44.2446 32.066 35.0306 32.066 35.0306H31.9761L27.8726 44.1699C27.8726 44.1699 27.7291 44.3359 27.603 44.3793C27.4769 44.4227 27.3833 44.4295 27.2586 44.3793C27.1338 44.329 27.004 44.125 27.004 44.125Z"
        fill="currentColor"
      />
      <path
        d="M30.4785 31.336C30.0142 31.1116 24.9073 18.9359 24.9073 18.9359L27.1687 18.0234L31.9312 28.6884H32.1408L36.8734 18.0683L39.0599 19.1602C39.0599 19.1602 33.7882 31.1565 33.5636 31.336C33.3389 31.5155 31.377 31.5903 30.4785 31.336Z"
        fill="currentColor"
      />
      <path
        d="M32 16C40.8366 16 48 23.1634 48 32C48 40.8366 40.8366 48 32 48C23.1634 48 16 40.8366 16 32C16 23.1634 23.1634 16 32 16ZM32.0713 17.5C24.0699 17.5002 17.5832 23.9933 17.583 32.0029C17.583 40.0127 24.0698 46.5066 32.0713 46.5068C40.073 46.5068 46.5596 40.0129 46.5596 32.0029C46.5594 23.9932 40.0728 17.5 32.0713 17.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
